// Types
import { CapitalizeType } from './transformText.types';

/**
 * An object that maps each `CapitalizeType` value to its corresponding transformation function.
 */
const types: { [Key in CapitalizeType]: (text: string) => string } = {
  lowercase: (text) => text.toLowerCase(),
  uppercase: (text) => text.toUpperCase(),
  titlecase: (text) => text.replace(/\b\w/g, (char) => char.toUpperCase()),
  sentencecase: (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase(),
};

/**
 * Transforms the given `text` based on the specified `capitalizeType`.
 *
 * @function
 * @param text - The text to transform.
 * @param capitalizeType - The type of capitalization to apply.
 * @returns The transformed text.
 */
export const transformText = (text: string, capitalizeType: CapitalizeType): string =>
  types[capitalizeType] ? types[capitalizeType](text) : text;
